import { Box, Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import {
  DrawerWidget,
  ModalComponent,
  SnackbarAlertWidget,
} from '../../../widgets';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import { USU_ENTIDADES_CONST } from '../../files/FilesAction';
import { setActivoUsuariosAction } from '../usuarios/UsuariosAction';
import FormNuevoUsuariosComponent from '../usuarios/components/FormNuevoUsuarios';
import SettingsUsuariosComponent from '../usuarios/components/SettingsUsuarios';
import { allUsuEntidadesAction } from './UsuEntidadesAction';
import AsignarUsuarioEntidad from './components/AsignarUsuarioEntidad';
import FiltrosUsuEntidadesComponent from './components/FiltrosUsuEntidades';
import ListadoUsuEntidades from './components/ListadoUsuEntidades';
import TodosCarnetsUsuEntidades from './components/TodosCarnetsUsuEntidades';

const UsuEntidadesView = () => {
  const dispatch = Redux.useDispatch();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const usuariosStore = Redux.useSelector((state) => state.usuarios);
  const usuEntidadesStore = Redux.useSelector((state) => state.usuEntidades);

  const [openModalForm, setOpenModalForm] = React.useState(false);
  const [modalCarnets, setModalCarnets] = React.useState(false);
  const [drawer, setDrawer] = React.useState(0);
  const [tipoForm, setTipoForm] = React.useState(0);

  // const selectPerfiles = (
  //   <FormControl sx={{ width: '100%' }} size="small">
  //     <InputLabel id="perfiles-label">Perfiles</InputLabel>
  //     <Select
  //       labelId="perfiles-label"
  //       id="perfiles"
  //       value={usuEntidadesStore.params.idPerfil}
  //       label="Perfiles"
  //       onChange={(event) => {
  //         dispatch({
  //           type: PARAMS_USU_ENTIDADES,
  //           payload: {
  //             ...usuEntidadesStore.params,
  //             idPerfil: event.target.value,
  //           },
  //         });
  //       }}
  //     >
  //       <MenuItem value={null}>TODOS</MenuItem>
  //       {perfilesStore.all.map((item) => (
  //         <MenuItem key={`perfil_${item.id}`} value={item.id}>
  //           {item.nombre}
  //         </MenuItem>
  //       ))}
  //     </Select>
  //   </FormControl>
  // );

  // React.useEffect(() => {
  //   const fetchData = async () => {
  //     await allUsuEntidadesAction(dispatch, {
  //       ...usuEntidadesStore.params,
  //       idEntidad: entidadesStore.activo.id,
  //     });
  //   };
  //   fetchData();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [usuEntidadesStore.params.idPerfil]);

  function getViewsDrawer(value) {
    switch (value) {
      case 1:
        return (
          <FiltrosUsuEntidadesComponent setDrawer={(val) => setDrawer(val)} />
        );
      case 2:
        return (
          <SettingsUsuariosComponent
            setModalCarnets={(val) => setModalCarnets(val)}
            setDrawer={(val) => setDrawer(val)}
            idEntidad={entidadesStore.activo.id}
            tipo={USU_ENTIDADES_CONST}
            params={usuEntidadesStore.params}
          />
        );
      default:
        return null;
    }
  }

  function openForm(tipo) {
    setActivoUsuariosAction(dispatch, null);
    setOpenModalForm(true);
    setTipoForm(tipo);
  }

  return (
    <Grid container spacing={1}>
      <SnackbarAlertWidget alert={usuariosStore.alertView} />
      <Grid
        item
        md={12}
        sx={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <Box>
          <BotonComponent click={() => openForm(0)} green mr={2} addIcon />
          <BotonComponent
            click={() => openForm(1)}
            blue
            mr={2}
            personAddIcon
            text="ASIGNAR"
          />

          <BotonComponent
            click={async () => {
              await setActivoUsuariosAction(dispatch, null);
              await allUsuEntidadesAction(
                dispatch,

                {
                  ...usuEntidadesStore.params,
                  idEntidad: entidadesStore.activo.id,
                },
              );
            }}
            disabled={
              usuEntidadesStore.loadingAll || usuEntidadesStore.all.length === 0
            }
            white
            refreshIcon
            text={
              usuEntidadesStore.loadingAll ? 'Actualizando...' : 'Actualizar'
            }
          />
          {/* {loginStore.isRoot && (
            <BotonComponent
              text="sincronizar"
              syncIcon
              blue
              click={async () => {
                const res = await sincronizarAction(dispatch, {
                  idEntidad: entidadesStore.activo.id,
                  download: true,
                });

                if (res) {
                  await getFileUrlAction(res.patch, res.filename);
                }
              }}
              ml={2}
            />
          )} */}
        </Box>
        <Box>
          <BotonComponent
            text="Filtros"
            filterIcon
            click={() => setDrawer(1)}
            white
          />
          {(!entidadesStore.settings.isBanda || loginStore.isRoot) && (
            <BotonComponent
              text="AJUSTES"
              settingsIcon
              blue
              click={() => setDrawer(2)}
              ml={1}
            />
          )}
        </Box>
      </Grid>
      {/* <Grid item md={12}>
        <Paper elevation={2} sx={{ width: '100%', p: 2 }}>
          <Grid
            container
            spacing={1}
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            <Grid item md={3}>
              {selectPerfiles}
            </Grid>
            <Grid item md={1}>
              <BotonComponent
                text="Buscar"
                click={() => {
                  allUsuEntidadesAction(
                    dispatch,
                    entidadesStore.activo.id,
                    usuEntidadesStore.params,
                  );
                }}
                green
                searchIcon
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid> */}
      <Grid item md={12}>
        <ListadoUsuEntidades
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </Grid>
      <DrawerWidget
        open={drawer !== 0}
        onClose={(val) => setDrawer(!val ? 0 : val)}
      >
        {getViewsDrawer(drawer)}
      </DrawerWidget>
      <ModalComponent
        id="modalFormUsuEntidades"
        title="Nuevo usuario"
        open={openModalForm}
        maxWidth={tipoForm === 0 ? 'lg' : 'xs'}
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        {tipoForm === 0 ? (
          <FormNuevoUsuariosComponent
            setOpenModalForm={(val) => setOpenModalForm(val)}
            isUsuarios={false}
          />
        ) : (
          <AsignarUsuarioEntidad
            setOpenModalForm={(val) => setOpenModalForm(val)}
          />
        )}
      </ModalComponent>
      <ModalComponent
        id="modal-carnets-codeqr"
        title="Descargar Carnet y Códigos QR"
        open={loginStore.isRoot && modalCarnets}
        maxWidth="xl"
        onClose={() => setModalCarnets(!modalCarnets)}
      >
        <TodosCarnetsUsuEntidades />
      </ModalComponent>
    </Grid>
  );
};

export default UsuEntidadesView;
